// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/collectionList.styl
// module id = 418
// module chunks = 0